import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MapFieldForm from './MapFieldForm';

export class DefaultPage extends Component {
  static propTypes = {
    import: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
    openItemList: PropTypes.func.isRequired,
    projectId: PropTypes.string.isRequired,
  };
  showCard = () => {
    return {
      display: !this.props.import.isOpenMappingPage ? 'none' : '',
    };
  };

  createSchemaForMapFields = () => {
    const { fields } = this.props.collection;
    let schema = {};
    Object.keys(fields).map((field) => {
      const fieldDetail = fields[field];
      schema[fieldDetail.fieldName] = '';
    });
    console.log('schemaa', schema);
    return schema;
  };
  closeFieldsMapping = () => {
    this.props.actions.closeImportMapping();
    this.openItemList();
  };
  openItemList = () => {
    this.props.openItemList(this.props.collection);
  };
  handleSubmit = (values) => {
    const { projectId, collection, version, actions } = this.props;
    let formData = { csvData: this.props.import.csvData, mappedFields: values };
    actions.importItemsFromCsvData({
      projectId,
      version,
      formData: formData,
      collectionName: collection.collectionName,
    });
    actions.closeImportMapping();
    this.openItemList();
  };

  render() {
    console.log('Mapping page:::', this.props);
    const { fields } = this.props.collection;
    const { isOpenMappingPage, csvHeader } = this.props.import;
    return (
      <React.Fragment>
        {isOpenMappingPage && fields.length > 0 && csvHeader.length > 0 ? (
          <div className="import-default-page">
            <div
              className="card create-page-card custom-item-List-page-card scroll"
              style={this.showCard()}
            >
              <Formik
                enableReinitialize={true}
                initialValues={this.createSchemaForMapFields()}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  this.handleSubmit(values);
                  setSubmitting(false);
                  resetForm();
                }}
              >
                {({ isSubmitting, values, setFieldValue }) => (
                  <Form>
                    <div className="card-header">
                      <div className="row">
                        <div className="col-md-4 text-left">Collection Fields Mapping</div>

                        <div className="col-md-8 text-right">
                          <button
                            type="button"
                            className="btn btn-dark btn-sm mr-2"
                            onClick={this.closeFieldsMapping}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-info btn-sm"
                            disabled={isSubmitting}
                          >
                            <i className="wb webconnect-download" /> Import
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="container">
                        <div className="row text-left">
                          <div className="col-md-6">
                            {fields
                              ? fields.map((field) => (
                                  <MapFieldForm
                                    key={field._id}
                                    field={field}
                                    values={values}
                                    import={this.props.import}
                                    setFieldValue={setFieldValue}
                                  />
                                ))
                              : ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    import: state.import,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
